import MovieIcon from '@mui/icons-material/Movie';
import { CardMedia } from '@mui/material';

/**
 * 16:9 placeholder when the edit has no thumbnail URL yet (movie icon only).
 */
export function EditCardMediaPlaceholder() {
  return (
    <CardMedia
      component="div"
      sx={{
        aspectRatio: '16/9',
        bgcolor: (theme) =>
          theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'grey.400',
      }}
    >
      <MovieIcon sx={{ fontSize: 48 }} />
    </CardMedia>
  );
}
